import { ListView } from "@progress/kendo-react-listview";
import {
  editedPropertyValues,
  galSessionData,
  items,
  propertiesVisible,
  propertiesWithHeaders,
  selectedFieldName,
  selectedFieldType,
  selectedGalleryFieldPropertyValues,
} from "./GalleryConstructorSignals";

const ItemRender = ({ props }) => {
  const handlePropertyChange = ({ propName, propValue }) => {
    editedPropertyValues.value = {
      ...editedPropertyValues.value,
      [selectedFieldName.value]: {
        ...editedPropertyValues.value[selectedFieldName.value],
        [propName]: propValue,
      },
    };
  };

  if (props.dataItem.id === 0) {
    return props.dataItem.renderer();
  }
  if (!propertiesVisible.value) {
    return;
  }
  if (props.dataItem.isHeader) {
    return props.dataItem.renderer();
  }

  return (
    <div className="align-rows">
      {props.dataItem.propertyDisplay}:
      {props.dataItem.renderer({
        handlePropertyChange,
        isGalleryEditor: true,
        currentPropertyValues: {
          ...selectedGalleryFieldPropertyValues.value,
          ...editedPropertyValues.value?.[selectedFieldName.value],
        },
        fieldType: selectedFieldType.value,
        galleryFields: galSessionData.value.map(({ fieldName, fieldType }) => ({
          text: fieldName,
          math: "Fields",
          expressionText: fieldName?.replace(/\s/g, ""),
          fieldType: fieldType,
        })),
      })}
    </div>
  );
};

export const GalleryConstructorPropertyPane = () => {
  return (
    <div className="gallery-constructor-drawer">
      <ListView
        style={{
          backgroundColor: "var(--atlas-bg-primary)",
          borderBottomRightRadius: "20px",
          overflowY: "auto",
        }}
        className={"gallery-constructor-drawer"}
        data={[...items.value, ...propertiesWithHeaders.value]}
        item={(props) => ItemRender({ props })}
      />
    </div>
  );
};
